import { Divider } from '@oliasoft-open-source/react-ui-library';
import { ICondition, IConditionGroup, QueryLogicalOperator } from 'common/interfaces/query';
import { Fragment } from 'react';
import { QueryConditionGroup } from './query-condition-group';
import { QueryLogicalOperatorSelect } from './query-logical-operator-select';

interface IQueryConditionGroupsProps {
  conditionGroups: IConditionGroup[];
  groupsOperator: QueryLogicalOperator;
  updateCondition: (groupIndex: number, conditionIndex: number, changes: Partial<ICondition>) => void;
  handleDeleteCondition: (groupIndex: number, conditionIndex: number) => void;
  handleAddCondition: (index: number) => void;
  setGroupOperator: (index: number, operator: QueryLogicalOperator) => void;
  setGroupsOperator:  (operator: QueryLogicalOperator) => void;
}

export const QueryConditionGroups = (
  {
    conditionGroups,
    handleAddCondition,
    handleDeleteCondition,
    updateCondition,
    setGroupOperator,
    setGroupsOperator,
    groupsOperator,
  }: IQueryConditionGroupsProps,
) => {
  return conditionGroups.map((conditionGroup, groupIndex) => (
    <Fragment key={groupIndex}>
      {groupIndex > 0 && (
        <Divider align="center">
          <QueryLogicalOperatorSelect value={groupsOperator} onChange={setGroupsOperator} />
        </Divider>
      )}
      <QueryConditionGroup
        conditionGroup={conditionGroup}
        updateCondition={(conditionIndex, changes) => updateCondition(groupIndex, conditionIndex, changes)}
        handleDeleteCondition={(conditionIndex) => handleDeleteCondition(groupIndex, conditionIndex)}
        handleAddCondition={() => handleAddCondition(groupIndex)}
        setOperator={(operator) => setGroupOperator(groupIndex, operator)}
      />
    </Fragment>
  ))
};
